"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pageAreasFromObj = void 0;
function pageAreasFromObj(obj) {
    return {
        pageIdx: obj.pageIdx,
        areas: (obj.areas || []).map(function (area) { return ({
            x: area.x,
            y: area.y,
            width: area.width,
            height: area.height
        }); })
    };
}
exports.pageAreasFromObj = pageAreasFromObj;
